"use client"

import { useEffect, useState } from 'react'
import { useStore } from '@/lib/store'
import { loadAiBrief, type AiBrief } from '@/lib/ai-brief-cache'

/**
 * The AI manager's state for this owner (2026-09-30): is it switched on for
 * the shop, and yesterday's note (124, /api/ai-brief) — one request per shop
 * and language per page load (lib/ai-brief-cache).
 */

export type { AiBrief }

/** Null until known; `enabled: false` for anyone but the owner of a switched-on shop. */
export function useAiBrief(lang: 'ka' | 'ru'): AiBrief | null {
  const isOwner = useStore((s) => s.userRole === 'owner')
  const orgId = useStore((s) => s.currentOrg?.id ?? null)
  const [brief, setBrief] = useState<AiBrief | null>(null)
  useEffect(() => {
    if (!isOwner || !orgId) { setBrief({ enabled: false, note: null, day: null }); return }
    let alive = true
    void loadAiBrief(lang, orgId).then((b) => { if (alive) setBrief(b) })
    return () => { alive = false }
  }, [isOwner, orgId, lang])
  return brief
}

/** Opens the chat from anywhere (the accounting card's „ჰკითხე"). */
export const AI_CHAT_EVENT = 'martepos:ai-chat'
export function openAiChat() {
  window.dispatchEvent(new CustomEvent(AI_CHAT_EVENT))
}
